import { styled } from "@mui/material";
import { colors } from "@constants/cssVariables";

export const Heading = styled("h3")<{ level: string }>(({ level }) => ({
  font: `var(--font-header-${level})`,
  color: colors.neutral90,
}));
